import type { ReactElement, ReactNode } from 'react';
import { createContext } from 'react';

import type { Session } from '@/types/session.types';

// Keep a stable default shape for tests/components that render without a provider.
// (Historically this context defaulted `user`/`org` to `{}`.)
const DEFAULT_SESSION = {
  org: {},
  token: '',
} as Session;

export const SessionContext = createContext<Session>(DEFAULT_SESSION);

export interface SessionProviderProps {
  session?: Session;
  children: ReactNode;
}

export function SessionProvider({
  session,
  children,
}: SessionProviderProps): ReactElement {
  return (
    <SessionContext.Provider value={session || DEFAULT_SESSION}>
      {children}
    </SessionContext.Provider>
  );
}
